import { Alert, AlertTitle, Button, DialogActions, DialogContent } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TbActivity, TbHistory } from "react-icons/tb";

import { useGetFormattedPassenger, useGetPassengerHistory } from "@/requests/passengers.queries";
import { usePlanActions, usePlanShowPassengerHistoryDialog } from "@/stores/use-plan-table";

import CommonPopup from "../CommonPopup";
import PassengerInfoCard from "../PassengerInfoCard";
import PassengerHistoryItem, { HistoryItemSkeleton } from "./PassengerHistoryItem";

function EmptyHistory() {
    return (
        <Alert color="info" icon={<TbActivity />}>
            <AlertTitle>Veri bulunamadı</AlertTitle>
            <div className="text-sm text-gray-500">Yolcu için aktivite geçmişi bulunamadı !</div>
        </Alert>
    );
}

function PassengerHistoryDialogContent() {
    const passengerId = usePlanShowPassengerHistoryDialog();

    // should be formatted id: OS-id-D
    const { t } = useTranslation();
    const { data, isPending } = useGetPassengerHistory({ passengerId });
    const { data: formattedPassenger, isPending: isFormattedPassengerPending } = useGetFormattedPassenger({
        passengerId,
    });
    const { updateShowPassengerHistoryDialog } = usePlanActions();
    const historyItems = useMemo(() => {
        return data?.map((item) => <PassengerHistoryItem key={item.id} item={item} />);
    }, [data]);
    const loading = isPending || isFormattedPassengerPending;

    if (!passengerId) return null;
    const onClose = () => {
        updateShowPassengerHistoryDialog();
    };

    return (
        <CommonPopup title={"Yolcu Geçmişi"} icon={TbHistory} open={true} size="md" onClose={onClose}>
            <>
                <DialogContent dividers className="h-[500px] overflow-y-auto">
                    {formattedPassenger && <PassengerInfoCard passenger={formattedPassenger} />}
                    <ol className="relative border-l border-gray-200  mx-2 ">
                        {loading ? <HistoryItemSkeleton /> : !data?.length ? <EmptyHistory /> : historyItems}
                    </ol>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={loading} autoFocus color="secondary" variant="outlined">
                        {t("buttons.close")}
                    </Button>
                </DialogActions>
            </>
        </CommonPopup>
    );
}

export default PassengerHistoryDialogContent;
